import { render, staticRenderFns } from "./ModalHistoricoBoleto.vue?vue&type=template&id=45d32a86&scoped=true"
import script from "./ModalHistoricoBoleto.vue?vue&type=script&lang=js"
export * from "./ModalHistoricoBoleto.vue?vue&type=script&lang=js"
import style0 from "./ModalHistoricoBoleto.vue?vue&type=style&index=0&id=45d32a86&prod&scoped=true&lang=css"
import style1 from "./ModalHistoricoBoleto.vue?vue&type=style&index=1&id=45d32a86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d32a86",
  null
  
)

export default component.exports